<div class="agpr-agent">
    <section class="agpr-agent-sidebar" [attr.aria-label]="'Common.layout.lhp' | localize">
        <agpr-agent-sidebar></agpr-agent-sidebar>
    </section>
    <main class="agpr-agent-content">
        <router-outlet></router-outlet>
    </main>
</div>
